@if (modal.active(); as m) {

  <!-- Backdrop -->
  <div class="mo-backdrop" (click)="modal.respond(false)" aria-hidden="true"></div>

  <!-- Dialog -->
  <div class="mo-dialog"
       role="alertdialog"
       aria-modal="true"
       [attr.aria-labelledby]="'mo-title'"
       [attr.aria-describedby]="'mo-message'">

    <!-- Header -->
    <div class="mo-dialog__header">
      <div class="mo-dialog__icon" [class.mo-dialog__icon--danger]="m.variant === 'danger'">
        @if (m.variant === 'danger') {
          <span class="material-symbols-outlined">warning</span>
        } @else {
          <span class="material-symbols-outlined">help</span>
        }
      </div>
      <h2 class="mo-dialog__title" id="mo-title">{{ m.title }}</h2>
    </div>

    <!-- Body -->
    <p class="mo-dialog__message" id="mo-message">{{ m.message }}</p>

    <!-- Footer -->
    <div class="mo-dialog__footer">
      <button class="mo-btn mo-btn--cancel" (click)="modal.respond(false)">
        {{ m.cancelLabel }}
      </button>
      <button
        class="mo-btn"
        [class.mo-btn--danger]="m.variant === 'danger'"
        [class.mo-btn--primary]="m.variant !== 'danger'"
        (click)="modal.respond(true)"
      >
        {{ m.confirmLabel }}
      </button>
    </div>

  </div>

}
